module.exports = __webpack_public_path__ + "static/media/keyboard.4d454495.png";